/* tslint:disable:max-line-length */
import { FuseNavigationItem } from 'fuseui';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Přehled',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/dashboard',
        role: 'other',
    },
    {
        id: 'users',
        title: 'Uživatelé',
        type: 'basic',
        icon: 'heroicons_outline:users',
        link: '/users',
        role: 'other',
    },
    {
        id: 'newsBanner',
        title: 'Novinky',
        type: 'basic',
        icon: 'feather:bell',
        link: '/news-banner',
        role: 'other',
    },
    {
        id: 'companies-group',
        title: 'Firmy',
        subtitle: 'Správa firem',
        type: 'group',
        children: [
            {
                id: 'companies',
                title: 'Seznam firem',
                type: 'basic',
                icon: 'feather:briefcase',
                link: '/companies',
                role: 'other',
            },
        ],
    },
    {
        id: 'import-group',
        title: 'Import dat',
        subtitle: 'Správa dat aplikace',
        type: 'group',
        children: [
            {
                id: 'import',
                title: 'Import dat',
                type: 'basic',
                icon: 'feather:database',
                link: '/import',
                role: 'other',
            },
        ],
    },
    {
        id: 'settings',
        title: 'Nastavení',
        subtitle: 'Nastavení aplikace',
        type: 'group',
        children: [
            {
                id: 'flags',
                title: 'Flagy',
                type: 'basic',
                icon: 'feather:flag',
                link: '/flags',
                role: 'other',
            },
            {
                id: 'videos',
                title: 'Videa',
                type: 'basic',
                icon: 'feather:video',
                link: '/videos',
                role: 'other',
            },
            {
                id: 'currentEvents',
                title: 'Kurzy',
                type: 'basic',
                icon: 'feather:book-open',
                link: '/current-events',
                role: 'other',
            }
        ],
    },
    // {
    //     id: 'app-group',
    //     title: 'Aplikace Lucky kids',
    //     subtitle: 'Vše co potřebujete vědět',
    //     type: 'group',
    //     children: [
    //         {
    //             id: 'support',
    //             title: 'Podpora',
    //             type: 'basic',
    //             icon: 'heroicons_outline:question-mark-circle',
    //             link: '/support'
    //         },
    //         {
    //             id: 'changelog',
    //             title: 'Changelog',
    //             type: 'basic',
    //             icon: 'heroicons_outline:newspaper',
    //             link: '/changelog'
    //         }
    //     ]
    // },
];

export const defaultNavigationNotAdmin: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Přehled',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/dashboard',
        role: 'other',
    },

    {
        id: 'app-group',
        title: 'Aplikace KFP Online',
        subtitle: 'Finanční kalkulačky',
        type: 'group',
        children: [
            {
                id: 'support',
                title: 'Podpora',
                type: 'basic',
                icon: 'heroicons_outline:question-mark-circle',
                link: '/support',
            },
            {
                id: 'changelog',
                title: 'Changelog',
                type: 'basic',
                icon: 'heroicons_outline:newspaper',
                link: '/changelog',
            },
        ],
    },
];

export const compactNavigation: FuseNavigationItem[] = [];
export const futuristicNavigation: FuseNavigationItem[] = [];
export const horizontalNavigation: FuseNavigationItem[] = [];
export const horizontalNavigationNotAdmin: FuseNavigationItem[] = [];
